import React from "react";

const UploadIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.0714 8.07007V10.8701C14.0714 11.9902 14.0714 12.5502 13.8534 12.978C13.6617 13.3544 13.3557 13.6603 12.9794 13.8521C12.5516 14.0701 11.9915 14.0701 10.8714 14.0701H5.27143C4.15132 14.0701 3.59127 14.0701 3.16345 13.8521C2.78712 13.6603 2.48116 13.3544 2.28941 12.978C2.07143 12.5502 2.07143 11.9902 2.07143 10.8701V8.07007M10.7381 4.73674L8.07143 2.07007M8.07143 2.07007L5.40476 4.73674M8.07143 2.07007V10.0701" stroke={props.color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default UploadIcon;